export function openHelpPanel() {
    const HELP_BUTTON_CSS_SELECTOR = '.helpButtonEnabled';

    const helpButton = document.querySelector<HTMLButtonElement>(HELP_BUTTON_CSS_SELECTOR);

    if (helpButton) {
        helpButton.click();
    }
}
